import React, { useState } from "react";

import { passwordStrength } from "check-password-strength";

import { changeAdminPassword } from "services";

import { incomplete, setLocalKlimVar, useCancelAsyncOnUnmount, useNavigate, useParams, useToggleNavs } from "utils";

import { Button, Col, Form, Input, InputPassword, Link, MainPage, Row, Message as message } from "components";

import { AccountLogo } from "pages/app/account/components/AccountLogo";

export const PasswordReset = () => {
  const [loading, setLoading] = useState(false);
  const signal = useCancelAsyncOnUnmount()();
  const navigate = useNavigate();
  const { token } = useParams();

  useToggleNavs(false, false);

  const complete = (v) => {
    if (v.password !== v.confirmPassword) {
      message({
        content: "The passwords don't match",
        icon: "gremlin",
      });
    }
    if (passwordStrength(v.password).id === 0) {
      message({
        content: "The password is too weak",
        icon: "gremlin",
      });
    }

    setLoading(true);

    changeAdminPassword({
      ...v,
      ...{ token: token, signal },
    })
      .then((res) => {
        setLocalKlimVar("token", res.token);
        navigate("/dashboard");
        message({
          content: "Password updated",
          icon: "gremlin",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <MainPage pageName={"sign-in-up"}>
      <Row className="mini-form">
        <Col>
          <AccountLogo />
          <Row>
            <Col>
              <h1>Reset your password</h1>
            </Col>
          </Row>
          <Row>
            <Col>
              <p className="margin-bottom-0">Choose and confirm your new password.</p>
            </Col>
          </Row>
          <Form name="password" className="margin-top-400" onFinish={(v) => complete(v)} onFinishFailed={(v) => incomplete(v)}>
            <Row>
              <Col>
                <Input
                  name="email"
                  label="Your email"
                  rules={[
                    {
                      required: true,
                      type: "email",
                    },
                  ]}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={12} md={12}>
                <InputPassword label="New password" name="password" rules={[{ required: true }]} />
              </Col>
              <Col sm={12} md={12}>
                <InputPassword name="confirmPassword" label="Confirm password" rules={[{ required: true }]} className="no-suffix" />
              </Col>
            </Row>
            <Row className="margin-bottom-200">
              <Col>
                <Link to="/sign-in">Remembered your password?</Link>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Item>
                  <Button type="primary" htmlType="submit" disabled={loading} loading={loading}>
                    Reset password
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
    </MainPage>
  );
};
